import React from 'react';

function SearchIcon(props) {
  return (
    <svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.65 19.275C24.65 23.1824 21.4824 26.35 17.575 26.35C13.6676 26.35 10.5 23.1824 10.5 19.275C10.5 15.3675 13.6676 12.2 17.575 12.2C21.4824 12.2 24.65 15.3675 24.65 19.275ZM23.2849 24.9848C21.8236 26.4461 19.8049 27.35 17.575 27.35C13.1153 27.35 9.5 23.7347 9.5 19.275C9.5 14.8153 13.1153 11.2 17.575 11.2C22.0347 11.2 25.65 14.8153 25.65 19.275C25.65 21.1444 25.0147 22.8655 23.9483 24.234L29.2071 29.4928L28.5 30.1999L23.2849 24.9848Z"
        fill="white"
      />
    </svg>
  );
}

export default SearchIcon;
